import { render } from "./CheckboxInput.vue?vue&type=template&id=0573c9e5&ts=true&lang=pug"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__